import PropTypes from "prop-types";
import SearchBar from "../user/search";
import { useUserContext } from "../../context/userContext";
import { Link } from "react-router-dom";
import bt from "../../assets/bt.svg";
import logo from "../../assets/tweezers.svg";
import group49 from "../../assets/Group 49.svg";

const Othernav = ({ headerDetails, navLink }) => {
  const { user } = useUserContext();
  const avatarUrl = `https://api.dicebear.com/7.x/identicon/svg?seed=${user?.user?.name}`;

  return (
    <nav className="bg-secondary p-6 text-white md:p-8">
      <div className="flex justify-between">
        <div className="flex gap-2 md:hidden">
          <span>
            {/* nav button */}
            <Link to={navLink} className="p-2  relative bottom-7 ">
              <img src={bt} alt="nav button" />
            </Link>
          </span>
          <span>
            <p className="inline-flex  font-bold text-white text-[16px]">
              {headerDetails}
            </p>
          </span>
        </div>

        <span>
          <img
            src={logo}
            className="block relative bottom-5 md:hidden h-6 m-4 md:h-8"
            alt="logo"
          />
        </span>
      </div>

      {/* Top Section */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <img
            src={logo}
            className="hidden md:block h-24 m-4 md:h-8"
            alt="logo"
          />
        </div>

        {/* <div className="relative md:left-16">
          {user?.user?.plan !== "free" && <SearchBar />}
        </div> */}
        <div className="hidden text-primary md:flex md:gap-2">
          <span>
            <img src={group49} alt="icon" />
          </span>
          <span>Top Picks</span>
        </div>
        <div className="flex relative right-16 md:right-0 items-center space-x-2">
          <img
            src={avatarUrl}
            alt="User Avatar"
            className="hidden md:flex rounded-full w-12 h-12 border border-amber-50 bg-amber-100"
          />
          <div className="hidden md:block">
            <p className="text-white font-light">
              Welcome,{" "}
              <span className="text-white font-semibold block">
                {user?.user?.name.split(" ")[0]}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="hidden md:flex gap-2 relative left-24 top-16">
          <span>
            {/* nav button */}
            <Link to={navLink} className="p-2  relative bottom-7 ">
              <img src={bt} alt="nav button" />
            </Link>
          </span>
          <span>
            <p className="inline-flex  font-bold text-white text-[16px]">
              {headerDetails}
            </p>
          </span>
        </div>
    </nav>
  );
};

Othernav.propTypes = {
  headerDetails: PropTypes.string.isRequired,
  navLink: PropTypes.string.isRequired, // Ensure navLink is required
};

export default Othernav;
